var window = require('./window');

function openTab(url) {
	return window.open(url);
}

module.exports = openTab;